import { createAsyncThunk } from "@reduxjs/toolkit";
import { getJobType } from "sr/utils/api/masterData/jobtype/getJobType";

const fetchJobType = createAsyncThunk('jobtype', async ()=> {
    const response = await getJobType()
    if(response?.success===true){
        return response?.data
    }

})
export default fetchJobType;